export default __webpack_public_path__ + "static/media/bscscan_p.d1cc8be4.png";